import React, { useState } from "react";
//import "./styles.css";
import { Row, Col, Form } from "react-bootstrap";

import "./addmember.css";
import DateTimePicker from "react-datetime-picker";

import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

const AddMember = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    name: "",
    contract: "",
    vacationClub: "",
    userType: "",
    password: "",
    email: "",
    firstActivationDate: new Date(),
    accountType: "",
    bookedReservation: "",
    otherId: "",
    membershipType: "",
    active: "",
    loggedIn: "",
  });

  const addMember = (e) => {
    e.preventDefault();
    setLoading(true);

    let member = user;

    axios
      .post(`/add-member`, { member }, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          message.success("add member success");
          setUser({
            name: "",
            contract: "",
            vacationClub: "",
            userType: "",
            password: "",
            email: "",
            firstActivationDate: new Date(),
            accountType: "",
            bookedReservation: "",
            otherId: "",
            membershipType: "",
            active: "",
            loggedIn: "",
          });
          setLoading(false);
        } else {
          message.error("failed adding member");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    // <div>
    //   <HeaderPart />
    //   <div className="main_cont">
    //     <LeftpanelMember />
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            {/* <h2>Hello, Admin!</h2> */}
            <Form onSubmit={addMember}>
              <div className="add_certificate">
                <h3>Add Contract ID</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          placeholder="Enter ID"
                          className="text_link"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              contract: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Vacation Club</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          placeholder="Enter Vacation Club"
                          className="text_link"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              vacationClub: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Member Name</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          placeholder="Enter Name"
                          className="text_link"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              name: e.target.value,
                            })
                          }
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Member Email</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          placeholder="Enter Email"
                          className="text_link"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              email: e.target.value,
                            })
                          }
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add User Type</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          as="select"
                          className="text_link bulk_select"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              userType: e.target.value,
                            })
                          }
                          required
                        >
                          <option>Select Type</option>
                          <option>Paid Member</option>
                          <option>1 Year</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Account Type</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          as="select"
                          className="text_link bulk_select"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              accountType: e.target.value,
                            })
                          }
                        >
                          <option>Select Type</option>
                          <option>Lifetime</option>
                          <option>1 Year</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Status</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          as="select"
                          className="text_link bulk_select"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              active: e.target.value,
                            })
                          }
                        >
                          <option>Select Status</option>
                          <option>Active</option>
                          <option>Inactive</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add First Activation Date</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <DateTimePicker
                          onChange={(e) =>
                            setUser({
                              ...user,
                              firstActivationDate: e,
                            })
                          }
                          value={user.firstActivationDate}
                          className="text_link w-100 px-3"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Logged In Status</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          as="select"
                          className="text_link bulk_select"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              loggedIn: e.target.value,
                            })
                          }
                        >
                          <option>Select Status</option>
                          <option>Yes</option>
                          <option>No</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Booked Reservation Status</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          as="select"
                          className="text_link bulk_select"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              bookedReservation: e.target.value,
                            })
                          }
                        >
                          <option>Select Status</option>
                          <option>Yes</option>
                          <option>No</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Other ID</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          placeholder="Enter Other Id"
                          className="text_link"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              otherId: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="add_certificate">
                <h3>Add Membership Type</h3>
                <div className="addcert_box1">
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          as="select"
                          className="text_link bulk_select"
                          onChange={(e) =>
                            setUser({
                              ...user,
                              vacationClub: e.target.value,
                            })
                          }
                        >
                          <option>Select Type</option>
                          <option>Gold Member</option>
                          {/* <option>No</option> */}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="sub_but">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>

        {/* <Modal show={show} onHide={handleClose}>
        <Modal.Body>
            <p>Are you sure you want to delete?</p>

            <div className="d-flex justify-content-center mt-4">
              <button type="button" className="yes_but">Yes</button>

              <button type="button" className="no_but">NO</button>
            </div>

        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal> */}
      </div>
    </LoadingOverlay>
    //   </div>
    // </div>
  );
};

export default AddMember;
